import React from "react";
import { Box, Heading, Text, Stack } from "@chakra-ui/react";

const RefundsCancellations: React.FC = () => {
  return (
    <Box>
      <Stack gap={6}>
        <Heading as="h2" size="lg" color="gray.800" mb={4}>
          Cashquin Website and Payment Services Refunds & Cancellations
        </Heading>

        <Text color="gray.600" lineHeight="1.6">
          This policy governs refund and cancellation requests for online
          payment transactions made through our platform.
        </Text>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Cancellation Policy
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • Once a Cashquin transaction is initiated, it cannot be cancelled if
              already processed by the biller/bank.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • If a transaction remains pending, we will coordinate with the
              bank/gateway for reversal where applicable.
            </Text>
          </Stack>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Refund Policy
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • Refunds are subject to biller confirmation and bank/gateway
              rules.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • On approved cases (duplicate debit, failed but debited), refunds
              may take 5–7 working days to reflect.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Refunds are credited to the original payment method only.
            </Text>
          </Stack>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Support & Dispute Resolution
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            For any refund-related queries, please contact us with the
            transaction reference number. We will liaise with the biller and
            payment partners to resolve the issue as per regulatory timelines.
          </Text>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Processing Timeline
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • Refund requests are processed within 24-48 hours of receipt.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Bank processing may take additional 5-7 working days.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • You will receive SMS/email notifications for status updates.
            </Text>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default RefundsCancellations;
